import { S3_BUCKET_URL } from '@/constants';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';

export const getCoinsUpsaleImage = (gender: string): string => {
  const paywallNotes = webCampaign.setup.paywallNotes;

  let version = '';

  if (paywallNotes.includes(PAYWALL_NOTES.COINS_UPSALE_V1)) {
    version = 'v1/';
  } else if (paywallNotes.includes(PAYWALL_NOTES.COINS_UPSALE_V2)) {
    version = 'v2/';
  } else if (paywallNotes.includes(PAYWALL_NOTES.COINS_UPSALE_V3)) {
    version = 'v3/';
  }

  return `${S3_BUCKET_URL}/modal-coins-upsale/${version}${gender}.png`;
};
